<div class="heading d-flex flex-wrap align-items-center justify-content-between mb-1" id="CommonPageHeader">
    <div class="page-header-title">
        <h3 class="mb-1 d-flex align-items-center gap-2">
            <ng-content select="[headerPrefix]"></ng-content>
            <span class="page-header-heading-text" [title]="Heading">{{Heading}}</span>
            <span style="color: var(--bs-primary);" *ngIf="details.length > 0">- {{details}}</span>
            <ng-content select="[headerSuffix]"></ng-content>
        </h3>
        <p class="text-muted mb-0">{{Description}}</p>
    </div>
    <div class="ms-auto d-flex align-items-center gap-2 page-header-actions">
        <ng-content></ng-content>
    </div>
</div>
